/* Uniko — audit du 2026-10-09 : quelques libellés du personnalisateur TeeInBlue restent en anglais ou sans accent
   (message de champ obligatoire, liste « Choose an option », bouton « Selectionner »). On les remplace à l'affichage.
   Solution durable : les corriger dans TeeInBlue (Settings › Translations) ; ce fichier pourra alors être retiré. */
(function () {
  var T = {
    "This field is required!": "Ce champ est obligatoire.",
    "Error: Some fields are required or invalid data": "Merci de compléter les champs obligatoires (marqués d’un *).",
    "Choose an option": "Choisissez…",
    "Selectionner": "Sélectionner",
    "Selectionner et continuer": "Sélectionner et continuer",
    "Chosissez une autre image": "Choisissez une autre image"
  };
  function passe(racine) {
    var w = document.createTreeWalker(racine, NodeFilter.SHOW_TEXT), n, L = [];
    while ((n = w.nextNode())) { var t = n.nodeValue.trim(); if (T[t]) L.push([n, t]); }
    L.forEach(function (x) { x[0].nodeValue = x[0].nodeValue.replace(x[1], T[x[1]]); });
  }
  var prevu = false;
  function planifier() {
    if (prevu) return; prevu = true;
    requestAnimationFrame(function () {
      prevu = false;
      document.querySelectorAll(".tee-campaign-form-wrapper, #teeinblue-wrapper, .tee-shopify-product, .tee-dialog").forEach(passe);
    });
  }
  function demarrer() { new MutationObserver(planifier).observe(document.body, { childList: true, subtree: true, characterData: true }); planifier(); }
  if (document.body) demarrer(); else document.addEventListener("DOMContentLoaded", demarrer);
})();
